<template>
  <div class="confirmation-sent-section">
    <h3 class="confirmation-sent-section__title">
      {{ $tc('SignupPage.ConfirmationSentPage.title') }}
    </h3>
    <div
      class="confirmation-sent-section__message"
      v-html="$tc('SignupPage.ConfirmationSentPage.message')"
    />

    <action-buttons-section
      class="confirmation-sent-section__action-buttons"
      scrollTargetSelector=".confirmation-sent-section"
      :visible="true"
    >
      <atom-input-button
        :linkText="$tc('SignupPage.ConfirmationSentPage.reEnter')"
        :isDisabled="false"
        colorType="secondary"
        @push="moveToEmailAuthentication"
      />
    </action-buttons-section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'
import StoreUtil from '@/store/StoreUtil'

/**
 * 新規会員登録:メール送信完了画面セクションのコンポーネント
 */
export default defineComponent({
  name: 'ConfirmationSentSection',
  components: {
    ActionButtonsSection,
    AtomInputButton,
  },
  setup() {
    const signupPageStore = StoreUtil.useStore('SignupPageStore')

    return {
      memberType: signupPageStore.memberType,
    }
  },
  methods: {
    moveToEmailAuthentication() {
      /**
       * 認証メール送信画面へ遷移
       */
      this.$router.replace({ path: `/signup/${this.memberType}` })
    },
  },
})
</script>

<style lang="scss" scoped>
.confirmation-sent-section {
  padding: 80px 16px;

  &__title {
    @include fontSetTextMedium(17);

    line-height: 1.41;
    font-weight: 500;
    letter-spacing: 0.04em;
    font-feature-settings: 'palt' on;
  }

  &__message {
    margin: 24px 0;
    @include fontSetTextMedium();

    font-feature-settings: 'palt' on;
  }

  &__action-buttons {
    bottom: 0;
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    padding: 80px 20px;
  }
}
</style>

<style lang="scss">
.confirmation-sent-section {
  &__message {
    > * + * {
      margin-top: 1.5em;
    }
  }
}
</style>
